import React,{useState, useEffect} from "react";
import styles from './MaskedLeadBanner.module.css'
import {googleAnalytics} from "../../Services/users"

interface MaskedLeadBannerProps{
    leads: any,
    ctaText: String,
    onClick: any,
    user:any,
}

const MaskedLeadBanner: React.FC<MaskedLeadBannerProps> = ({leads, ctaText, onClick,user}) => {
    const [isGACalled, setIsGACalled] = useState<any>(false);
       useEffect(()=>{
         if(isGACalled === false){
           if(user?.uid && user?.profile){
             setIsGACalled(true)
             googleAnalytics('booster banner impression | readpro',user)
           }
         }
       },[user])
     
    return(
        <div className={styles.Mlb}>
            <div className={styles.Mlbwrap}>
                <div className={styles.MlbAlert}><span className={`${styles.TextYellow} ${styles.TextBold}`}>Alert!</span> Your listings received <span className={`${styles.TextPink} ${styles.TextBold}`}>{leads}</span> <span className={`${styles.TextBold}`}>Additional Leads</span> last month - <span className={`${styles.TextPink} ${styles.TextBold}`}>All Locked</span><span className={styles.Lock}>&#128274;</span></div>
                <div className={styles.MlbText}>These Leads on your listing were locked because you do not have the active booster pack</div>
                <div className={styles.MlbActBlock}>
                    <div className={styles.MlbActBlockText}>To get these <span className={styles.TextRed}>{leads}</span> locked leads next month </div>
                    <span className={styles.MlbCtaGreen} onClick={onClick}>{ctaText}</span>
                </div>
                <div className={styles.MlbActBlockText}> Easy Monthly Subscription of Booster pack Available</div>
            </div>
        </div>
    )
}

export default MaskedLeadBanner